import Collapse from '@mui/material/Collapse';
import { TransitionGroup } from 'react-transition-group';
import CircularProgress from '@mui/material/CircularProgress';
import { useState } from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './index.module.sass';
import { styled } from '@mui/material/styles';

const date = new Date();

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#002747',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 100,
    backgroundColor: '#002747',
  },
});

function renderItem({
  imagen,
  descri,
  clave,
  cantidad,
  letra,
  precio,
  importe,
  status,
  onQuantityChange,
  screenSize,
  loading,
  agrupador,
  t,
}) {
  return (
    <div className={`${styles.container} ${styles[screenSize]} ${status !== '' && styles.alert}`}>
      {/* <i
        className={`material-icons-outlined ${styles.icon}`}
        onClick={() => onQuantityChange('delete')}>
        close
      </i> */}
      <div className={styles.image}>
        <img
          src={`${imagen}?x=${date.getFullYear()}${date.getMonth() + 1}`}
          alt={descri}
          onError={(event) => {
            event.target.src =
              'https://webimages.terramarbrands.com.mx/images-usa/shopping-cart/cart-products-gray/preload.jpg';
            event.onerror = null;
          }}
        />
      </div>
      <div className={`${styles.column} ${styles.product}`}>
        <div className={styles.name}>
          <label className={styles.idname}>
            <label className={styles.id}>{clave}</label> -{' '}
            <label className={styles.labelname}>{descri}</label>
          </label>
        </div>
      </div>

      {((status === 'Producto Agotado.' || status === 'Product Sold Out.') && (
        <div className={`${styles.column} ${styles.soldout}`}>
          <label>{t('defaultSoldOut')}</label>
          {agrupador !== 'COMPONENTES' && agrupador !== 'REGALOS' && agrupador !== 'TAX' && (
            <i
              className={`material-icons-outlined ${styles.icon}`}
              onClick={() => onQuantityChange('delete')}>
              delete
            </i>
          )}
        </div>
      )) || (
        <div className={`${styles.column} ${styles.actions}`}>
          {(agrupador === 'COMPONENTES' && <span>{t('isComponent')}</span>) ||
            (agrupador === 'REGALOS' && <span>{t('isGift')}</span>) ||
            (agrupador === 'TAX' && <span>{t('isTax')}</span>) ||
            (loading && <CircularProgress className={styles.circular} />) || (
              <>
                {cantidad > 1 && (
                  <i
                    className={`material-icons ${styles.icon}`}
                    onClick={() => onQuantityChange('less')}>
                    remove
                  </i>
                )}
                {/* <label>1</label> */}
                <i
                  className={`material-icons ${styles.icon}`}
                  onClick={() => onQuantityChange('add')}>
                  add
                </i>
                <i
                  className={`material-icons-outlined ${styles.icon}`}
                  onClick={() => onQuantityChange('delete')}>
                  delete
                </i>
              </>
            )}
        </div>
      )}
      <div className={`${styles.column}`}>{cantidad}</div>
      <div className={`${styles.column}`}>${precio}</div>
      <div className={`${styles.column}`}>${importe}</div>
      <div className={`${styles.column}`}>
        {status !== '' && (
          <CustomWidthTooltip title={status} placement='right' arrow>
            {<span className={`material-icons-outlined ${styles.tooltip}`}>report_problem</span>}
          </CustomWidthTooltip>
        )}
      </div>
    </div>
  );
}

//BORRARPRO
export default function OrderTable({ node, getOrder, device }) {
  const {
    agrupador = '',
    imagen = '',
    clave = '',
    descri = '',
    cantidad = '',
    letra = '',
    precio = '',
    importe = '',
    status = '',
    categoria = '',
    numeroLinea = '',
  } = node;

  const [loading, setloading] = useState(false);

  const { t } = useTranslation('products');

  const screenSize = device?.screenSize || 'desktop';

  async function onQuantityChange(action) {
    setloading(true);
    if (action === 'add')
      await getOrder('ORDENARTAX', categoria, clave, parseInt(cantidad) + 1, numeroLinea, false);
    else if (action === 'delete') {
      await getOrder('BORRARPRO', categoria, clave, parseInt(cantidad), numeroLinea, false);
    } else {
      if (parseInt(cantidad) <= 1) return;
      else
        await getOrder('ORDENARTAX', categoria, clave, parseInt(cantidad) - 1, numeroLinea, false);
    }
    setloading(false);
  }
  return (
    <div>
      <TransitionGroup>
        <Collapse key={clave} timeout={500}>
          {renderItem({
            imagen,
            descri,
            clave,
            cantidad,
            letra,
            precio,
            importe,
            status,
            onQuantityChange,
            screenSize,
            loading,
            agrupador,
            t,
          })}
        </Collapse>
      </TransitionGroup>
    </div>
  );
}
